module.exports = __webpack_public_path__ + "static/img/exam_list.5a40503b.png";